import { ReferenceInput, SelectInput, required } from "react-admin";

const TemplateSelector = (props: Record<string, unknown>) => (
  <ReferenceInput
    source="templateName"
    reference="whatsappTemplates"
    filter={{ status: "APPROVED" }}
    perPage={1000}
    {...props}
  >
    <SelectInput
      label="Template"
      optionText={(record) => `${record.name} (${record.category})`}
      optionValue="name"
      validate={required()}
      fullWidth
      sx={{
        width: "100%",
        maxWidth: "100%",
        minWidth: 0,
        "& .MuiFormControl-root": { width: "100%", maxWidth: "100%", minWidth: 0 },
      }}
    />
  </ReferenceInput>
);

export default TemplateSelector;
